import React from 'react';
import SalesQuestDashboard from './SalesQuestDashboard';
import './App.css';

function App() {
  return (
    <div className="App">
      <SalesQuestDashboard />
    </div>
  );
}

export default App;
